// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"7eb49e0e","693":"7a729ed2","787":"100a6466","957":"5a7d2770"}[chunkId] + ".chunk.js";
};